import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Spinner } from '@repo/ui/spinner';
import { WorkflowEventsLog } from './workflow-events-log';

type ProcessingViewProps = {
  reportId: string;
  onCompleted?: () => void;
};

export const ProcessingView = ({ reportId, onCompleted }: ProcessingViewProps) => {
  useLocale();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-3">
        <Spinner className="h-5 w-5 text-primary" />
        <div>
          <h2 className="font-semibold text-lg">{t('auth.reportProcessing')}</h2>
          <p className="text-muted-foreground text-sm">
            {t('auth.theReportIsBeingGeneratedThisMayTakeA')}{' '}
          </p>
        </div>
      </div>

      <WorkflowEventsLog onCompleted={onCompleted} reportId={reportId} />
    </div>
  );
};
